import * as React from 'react';
import { css } from 'emotion';

import { Merchant } from '../../models/merchant.model';

export interface Props {
  merchant?: Merchant;
};

export const MerchantContactInfo = (props: Props) => {
  if (!props.merchant) {
    return null;
  }

  return (
    <div className={css`margin-top: 20px`}>
      {props.merchant.name} <br />
      Call or Text: {props.merchant.phoneNumber} <br />
      Email: {props.merchant.email}
    </div>
  );
};
